export default function EmailIcon({
    style,
    fill="#E8E8E8"
}){
    return <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 3C1 1.89543 1.89543 1 3 1H15C16.1046 1 17 1.89543 17 3V12.3333C17 12.5101 16.9298 12.6797 16.8047 12.8047C16.6797 12.9298 16.5101 13 16.3333 13H1.66667C1.48986 13 1.32029 12.9298 1.19526 12.8047C1.07024 12.6797 1 12.5101 1 12.3333V3Z" stroke="#536987" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16.3618 1.95996L9.00175 9.29329L1.48175 1.95996" fill="#83CFA4"/>
    <path d="M16.3618 1.95996L9.00175 9.29329L1.48175 1.95996" stroke="#536987" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
    
}